module.exports = __webpack_public_path__ + "media/placeholder-images/placeholder_9-0fc8a58b.jpg";